@if (myFormControl?.value && !isUnassignedPopulation) {
<div
  #globe
  class="globe icon"
  (click)="setGlobal(question)"
  [ngClass]="{ disabled: !(question?.answers)[0]?.isGlobal }"
></div>
}

<div class="ui inverted popup" *transloco="let t">
  {{
    (question?.answers)[0]?.isGlobal
      ? t(
          "clients.this-answer-is-global-across-all-populations-for-this-client"
        )
      : t("clients.click-to-save-answer-to-all-populations-for-this-client")
  }}
</div>
